<template>
  <div>
    <div class="prize-wrapper">
      <!-- 奖品图 -->
      <img :src="awardImgSrc" alt />
    </div>
    <div class="activity-wrapper" :style="activityImgStyle">
      <fragment v-if="activityStatus >= 3 && isUserBindMobile">
        <h2>
          <span :style="energyOption('current').fontStyle">{{
            energyOption("current").leftText
          }}</span>
          <span :style="energyOption('current').countStyle">{{
            userActivityScore
          }}</span>
          <span :style="energyOption('current').fontStyle">{{
            energyOption("current").rightText
          }}</span>
        </h2>
        <p v-if="actiyNumber.ingShowTotal">
          <span :style="energyOption('all').fontStyle">{{
            energyOption("all").leftText
          }}</span>
          <span :style="energyOption('all').countStyle">{{
            totalActivityScore
          }}</span>
          <span :style="energyOption('all').fontStyle">{{
            energyOption("all").rightText
          }}</span>
        </p>
      </fragment>
    </div>
    <div
      v-if="activityStatus >= 3"
      class="rank-wrapper"
      :style="{
        'background-image': 'url(' + actiNumberRank.backgroundImg + ')',
      }"
    >
      <ul>
        <li :key="index" v-for="(item, index) in topList">
          <div>
            <span v-if="index == 0 && actiNumberRank.topOne">
              <img :src="actiNumberRank.topOne" alt />
            </span>
            <span v-else-if="index == 1 && actiNumberRank.topTwo">
              <img :src="actiNumberRank.topTwo" alt />
            </span>
            <span v-else-if="index == 2 && actiNumberRank.topThree">
              <img :src="actiNumberRank.topThree" alt />
            </span>
            <span
              :style="index < ruleList.winNumber ? winStyle : rankingStyle"
              v-else
              >{{ index + 1 }}</span
            >
            <span
              :style="index < ruleList.winNumber ? winStyle : rankingStyle"
              >{{ item["userPhoneDesc"] }}</span
            >
            <span
              :style="index < ruleList.winNumber ? winStyle : rankingStyle"
              >{{ item["useScoreDesc"] }}</span
            >
          </div>
        </li>
      </ul>
    </div>
    <div
      v-if="activityStatus == 3"
      class="swiper-wrapper swiper-no-swiping"
      :style="{ 'background-image': 'url(' + swiper.backgroundImg + ')' }"
    >
      <swiper
        v-if="addScoreUserList.length > 0"
        :auto-update="true"
        :auto-destroy="true"
        :delete-instance-on-destroy="true"
        :cleanup-styles-on-destroy="true"
        ref="mySwiper"
        :options="swiperOptions"
      >
        <swiper-slide
          :style="swiperStyle"
          :key="index"
          v-for="(item, index) in addScoreUserList"
        >
          {{ item.userPhoneDesc }}下单了，获得{{ item.addScores
          }}{{ swiper.countName }}
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
import { isMiniApplets } from "@/utils/browser";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "Ranking",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    activityId: {
      type: String,
      required: true,
    },
    openId: {
      type: String,
      required: true,
    },
    activityStatus: {
      //活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      type: Number,
      required: true,
    },
    activityType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // activityStatus: 3, //活动状态 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      isUserBindMobile: false, //是否有手机号
      isUserWin: false, //是否中奖
      // 奖品信息图配置
      prizeInfo: {},
      // "活动数值显示设置"
      actiyNumber: {},
      // 活动数值排行设置
      actiNumberRank: {},
      // 得数值轮播区域设置
      swiper: {},
      userActivityScore: "", //用户当前数值
      totalActivityScore: "", //用户总数值
      addScoreUserList: [], //轮播数值
      topList: [], //排行榜
      activityOption: {},
      swiperOptions: {
        notNextTick: true,
        initialSlide: 0,
        direction: "vertical", //控制滚动的方向
        autoplay: {
          disableOnInteraction: false,
          delay: 2000, //这里需要注意，如果想每2秒去自动切换，直接autoplay:2000是失效的，
        },
        loop: true,
        loopedSlides: 10,
        height: 55,
        disableOnInteraction: false,
      },
      ruleList: {},
    };
  },
  computed: {
    awardImgSrc() {
      // 奖品图地址
      let imgSrc;
      let prizeInfo = this.info.props.imgList.prizeInfo;
      if (prizeInfo.isCoincide) {
        if (this.activityStatus < 3) {
          imgSrc = prizeInfo.startAward;
        } else {
          imgSrc = prizeInfo.endAward;
        }
      } else {
        imgSrc = prizeInfo.noStatus;
      }
      // if (this.activityStatus < 3) {
      //   imgSrc = prizeInfo.startAward;
      // } else {
      //   if (prizeInfo.isCoincide) {
      //     imgSrc = prizeInfo.startAward;
      //   } else {
      //     imgSrc = prizeInfo.endAward;
      //   }
      // }
      return imgSrc;
    },
    activityImgStyle() {
      //计算活动数值显示背景图 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      let bgImg;
      let actiyNumber = this.info.props.imgList.actiyNumber;
      console.log(this.isUserBindMobile);
      if (!this.isUserBindMobile) {
        bgImg = actiyNumber.unbindBgc;
      } else {
        if (this.activityStatus <= 2) {
          bgImg = actiyNumber.startBgc;
        } else if (this.activityStatus == 3) {
          bgImg = actiyNumber.ingBgc;
        } else if (this.activityStatus == 4) {
          if (this.isUserWin) {
            //是否中奖
            bgImg = actiyNumber.endWinBgc;
          } else {
            bgImg = actiyNumber.endUnWinBgc;
          }
        }
      }
      let imgStyle = {
        "background-image": `url(${bgImg})`,
      };
      return imgStyle;
    },
    rankingStyle() {
      let actiNumberRank = this.info.props.imgList.actiNumberRank;
      // 活动数值排行设置
      let rankingStyle = {
        "font-size": actiNumberRank.countfontSize / 2 + "px",
        color: actiNumberRank.countColor,
        "font-weight": actiNumberRank.countFontStyle.includes("bold")
          ? "bold"
          : "",
        "font-style": actiNumberRank.countFontStyle.includes("italic")
          ? "italic"
          : "",
        "text-stroke": `1px ${actiNumberRank.countBoxShadow}`,
      };
      return rankingStyle;
    },
    swiperStyle() {
      // 滚动轮播的字体颜色设置
      let swiper = this.info.props.imgList.swiper;
      return {
        "font-size": swiper.countfontSize / 2 + "px",
        color: swiper.countColor,
        "font-weight": swiper.countFontStyle.includes("bold") ? "bold" : "",
        "font-style": swiper.countFontStyle.includes("italic") ? "italic" : "",
        "text-stroke": `1px ${swiper.countBoxShadow}`,
      };
    },
    energyOption() {
      //计算活动数值 字体样式 数值 等 (0,"未发布"),(1,"已发布"),(2,"未开始"),(3,"进行中"),(4,"已结束"),
      return (str) => {
        //str=> 当前 总共
        let fontStyle = {}; //文字样式
        let countStyle = {}; //数字样式
        let leftText = ""; //左边文字
        let rightText = ""; //右边文字
        let textShadow = "";
        let countShadow = "";
        let actiyNumber = this.info.props.imgList.actiyNumber;
        if (str == "current") {
          if (this.activityStatus == 3) {
            // 当前数值且活动状态为进行中的
            textShadow = actiyNumber.ingFontBoxShadow;
            countShadow = actiyNumber.ingCountBoxShadow;
            fontStyle = {
              "font-size": `${actiyNumber.ingFontfontSize / 2}px`,
              color: actiyNumber.ingFontColor,
              "font-style": actiyNumber.ingFontFontStyle.includes("italic")
                ? "italic"
                : "",
              "font-weight": actiyNumber.ingFontFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${textShadow}`,
            };
            countStyle = {
              "font-size": `${actiyNumber.ingCountfontSize / 2}px`,
              color: actiyNumber.ingCountColor,
              "font-style": actiyNumber.ingCountFontStyle.includes("italic")
                ? "italic"
                : "",
              "font-weight": actiyNumber.ingCountFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${countShadow}`,
            };
            leftText = actiyNumber.ingLeftInput;
            rightText = actiyNumber.ingRightInput;
          } else if (this.activityStatus == 4) {
            // 当前数值且活动状态为结束的
            textShadow = actiyNumber.endFontBoxShadow;
            countShadow = actiyNumber.endCountBoxShadow;
            fontStyle = {
              "font-size": `${actiyNumber.endFontfontSize / 2}px`,
              color: actiyNumber.endFontColor,
              "font-style": actiyNumber.endFontFontStyle.includes("italic")
                ? "italic"
                : "",
              "font-weight": actiyNumber.endFontFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${textShadow}`,
            };
            countStyle = {
              "font-size": `${actiyNumber.endCountfontSize / 2}px`,
              color: actiyNumber.endCountColor,
              "font-style": actiyNumber.endCountFontStyle.includes("italic")
                ? "italic"
                : "",
              "font-weight": actiyNumber.endCountFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${countShadow}`,
            };
            leftText = actiyNumber.endLeftInput;
            rightText = actiyNumber.endRightInput;
          }
        } else {
          if (this.activityStatus == 3) {
            // 总数值且活动状态为进行中的
            textShadow = actiyNumber.ingTotalFontBoxShadow;
            countShadow = actiyNumber.ingTotalCountBoxShadow;
            fontStyle = {
              "font-size": `${actiyNumber.ingTotalFontfontSize / 2}px`,
              color: actiyNumber.ingTotalFontColor,
              "font-style": actiyNumber.ingTotalFontFontStyle.includes("italic")
                ? "italic"
                : "",
              "font-weight": actiyNumber.ingTotalFontFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${textShadow}`,
            };
            countStyle = {
              "font-size": `${actiyNumber.ingTotalCountfontSize / 2}px`,
              color: actiyNumber.ingTotalCountColor,
              "font-style": actiyNumber.ingTotalCountFontStyle.includes(
                "italic"
              )
                ? "italic"
                : "",
              "font-weight": actiyNumber.ingTotalCountFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${countShadow}`,
            };
            leftText = actiyNumber.ingTotalLeftInput;
            rightText = actiyNumber.ingTotalRightInput;
          } else if (this.activityStatus == 4) {
            // 总数值且活动状态为结束的
            textShadow = actiyNumber.endTotalFontBoxShadow;
            countShadow = actiyNumber.endTotalCountBoxShadow;
            fontStyle = {
              "font-size": `${actiyNumber.ingTotalFontfontSize / 2}px`,
              color: actiyNumber.endTotalFontColor,
              "font-style": actiyNumber.endTotalFontFontStyle.includes("italic")
                ? "italic"
                : "",
              "font-weight": actiyNumber.endTotalFontFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${textShadow}`,
            };
            countStyle = {
              "font-size": `${actiyNumber.ingTotalCountfontSize / 2}px`,
              color: actiyNumber.endTotalCountColor,
              "font-style": actiyNumber.endTotalCountFontStyle.includes(
                "italic"
              )
                ? "italic"
                : "",
              "font-weight": actiyNumber.endTotalCountFontStyle.includes("bold")
                ? "bold"
                : "",
              "text-stroke": `1px ${countShadow}`,
            };
            leftText = actiyNumber.endTotalLeftInput;
            rightText = actiyNumber.endTotalRightInput;
          }
        }
        return { fontStyle, countStyle, leftText, rightText };
      };
    },
    winStyle() {
      let actiNumberRank = this.info.props.imgList.actiNumberRank;
      return {
        "font-size": actiNumberRank.countfontSize / 2 + "px",
        color: actiNumberRank.countColorWin,
        "text-stroke": `1px ${actiNumberRank.countBoxShadowWin}`,
        "font-weight": actiNumberRank.countFontStyle.includes("bold")
          ? "bold"
          : "",
        "font-style": actiNumberRank.countFontStyle.includes("italic")
          ? "italic"
          : "",
      };
    },
  },
  mounted() {
    this.formatData();
    this.getRankingInfo();
  },
  methods: {
    // 解析父组件传递过来的数据
    formatData() {
      console.log(this.info);
      this.prizeInfo = this.info.props.imgList.prizeInfo;
      this.actiyNumber = this.info.props.imgList.actiyNumber;
      this.actiNumberRank = this.info.props.imgList.actiNumberRank;
      this.swiper = this.info.props.imgList.swiper;
      this.ruleList = this.info.props.ruleList;
    },
    // 获取竞排信息
    getRankingInfo() {
      let params = {
        activityId: this.activityId,
        openId: this.openId,
        pageShowCount: parseInt(this.actiNumberRank.endTopNumber),
      };
      this.$fetch(
        { url: "/ehs/activity/user/race/page", method: "post" },
        params
      ).then((res) => {
        if (res.success) {
          this.userActivityScore = res.model.userActivityScore;
          this.totalActivityScore = res.model.totalActivityScore;
          this.addScoreUserList = res.model.addScoreUserList;
          this.topList = res.model.topList;
          this.isUserBindMobile = res.model.isUserBindMobile;
          console.log(res.model);
          this.isUserWin = res.model.isUserWin;
        } else {
          this.$toast({
            styles: {
              maskColor: "rgba(0,0,0,0)",
              background: "rgba(0,0,0,0.4)",
              messageColor: "#fff",
            },
            content: res.errorMessage,
            duration: 2000,
          }).then(() => {
            console.log("finish");
          });
        }
      });
    },
    slide() {},
    onTap() {},
    onInit() {},
  },
};
</script>
<style lang="scss" scoped>
.prize-wrapper {
  height: 544px;
  overflow: hidden;
  display: flex;
  img {
    flex: 1;
    width: 100%;
  }
}
.activity-wrapper {
  width: 100vw;
  display: flex;
  height: 280px;
  background-size: 100% 100% !important;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  h2,
  p {
    display: flex;
    align-items: center;
  }
}
.rank-wrapper {
  height: 718px;
  padding: 96px 40px 18px;
  box-sizing: border-box;
  background-size: 100% 100% !important;
  overflow: hidden;
  ul {
    height: 100%;
    overflow-y: auto;
  }
  li {
    div {
      height: 60px;
      line-height: 60px;
      display: flex;
      flex-direction: row;
      font-size: 30px;
      text-align: center;
    }
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
  span:nth-of-type(1) {
    width: 23.5%;
  }
  span:nth-of-type(2) {
    flex: 1;
  }
  span:nth-of-type(3) {
    width: 33.5%;
  }
}
.swiper-container {
  width: 100%;
}
.swiper-wrapper {
  height: 680px;
  padding: 10px 40px 25px;
  background-size: 100% 100% !important;
  box-sizing: border-box;
  // touch-action: none;
  .swiper-slide {
    display: flex;
    align-items: center;
    font-size: 30px;
    justify-content: center;
    color: #fff;
    p {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>